import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { release } from 'os';

@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {
  private secretKey: string = 'SEP!DZN!M@AZ!NSHOHR@T@L!S@F@!E';
  constructor() { }

  //The set method is use for encrypt the value.
  set(value) {
    var encrypted = CryptoJS.AES.encrypt(value.toString(), this.secretKey);

    return `SEP!DZ${encrypted.toString()}`;
  }

  //The get method is use for decrypt the value.
  get(value) {
    if (value && value.substring(0, 6) === 'SEP!DZ') {
      value = value.replace('SEP!DZ', '');
      var decrypted = CryptoJS.AES.decrypt(value, this.secretKey);
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
    return value;
  }
}
